import React from 'react';
import { OFFER_ANCHOR, PRODUCT_IMAGE } from '../data/config';
type ProductImageProps = {
  className?: string;
  linkToOffer?: boolean;
};
export function ProductImage({
  className = '',
  linkToOffer = true
}: ProductImageProps) {
  const img = <img src={PRODUCT_IMAGE} alt="Caja coleccionable ATLAS MIOFASCIAL™ — 6 volúmenes + 5 bonos, 440 páginas de recursos clínicos" className={`mx-auto block h-auto w-full object-contain ${className}`} data-id="element-147" data-mp="2lk5034httt34" />;
  if (!linkToOffer) return img;
  return <a href={OFFER_ANCHOR} aria-label="Ir a la oferta especial" className="block" data-id="element-148" data-mp="27lf5pwme67ig">
      {img}
    </a>;
}